import { User, UserDetails } from '../../types/User';
import { USER_MANAGEMENT_BASE_URL } from '../consts';
import { NullableFields, RequiredFieldsOf } from '../../../../types/types';
import { usePatch, UsePatchParams } from '../../../../api/mutations/usePatch';
import { useCallback } from 'react';

type MinimalUserDetailsFields = RequiredFieldsOf<UserDetails>;
type MinimalUserDetails = Pick<UserDetails, MinimalUserDetailsFields>;

export type UpdateUserDetails = Partial<
    MinimalUserDetails & NullableFields<Omit<UserDetails, MinimalUserDetailsFields>>
>;

export type UseUpdateUserParams = UsePatchParams<UpdateUserDetails, {}>;

export const useUpdateUser = (params: UseUpdateUserParams) => {
    const { patch, ...rest } = usePatch<UpdateUserDetails, {}>(params);

    const updateUser = useCallback(
        (userGuid: User['guid'], details: UpdateUserDetails) =>
            patch(`${USER_MANAGEMENT_BASE_URL}/${userGuid}`, details),
        [patch]
    );

    return {
        ...rest,
        updateUser
    };
};

export const useUpdateUsers = (params: UseUpdateUserParams) => {
    const { patch, ...rest } = usePatch<UpdateUserDetails[], {}>(params);

    const updateUsers = useCallback(
        (details: UpdateUserDetails[]) => patch(`${USER_MANAGEMENT_BASE_URL}/users`, details),
        [patch]
    );

    return {
        ...rest,
        updateUsers
    };
};
